export default {
	channel: 'Distribuční kanál',
	agency: 'Oblast',
	region: 'Region',
	manager: 'Manažer',
	seller: 'Obchodník',
	ppz: 'Podobchodník',
};
